import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取验证码
   */
  // static getVerifyCode(params) {
  //   return request({
  //     url: `verifyCode/getVerifyCode`,
  //     host: config.HOST_STORE,
  //     params,
  //   });
  // }

  static getVerifyCode(params) {
    return request({
      url: `user/verifyCode/getVerifyCodeV3`,
      host: config.HOST_MALL,
      ignoreErr: true,
      params
    });
  }

  /**
   * 注册 - 店铺新客注册时
   */
  static register(params) {
    return request({
      url: 'valetOpenCard/confirmOrRegister',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  static queryCanApplyType(params) {
    return request({
      url: 'valetOpenCard/checkOpenCardAttribute',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取老客升级卡类型列表
   */
  static getCardTypeList(url, params) {
    return request({
      url,
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取老客升级卡类型列表
   */
  static getNormalCardTypeList(url, params) {
    return request({
      url,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 校验实体卡密是否正确
   */
  static applyPhysicalCard(params) {
    return request({
      url: 'valetOpenCard/checkEntityCard',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 提交开卡信息
   */
  static submitCardMsg(params) {
    return request({
      url: `valetOpenCard/queryCardType`,
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 根据手机号获取健康顾问
   */
  static gethealtyByPhone(params) {
    return request({
      url: `user/info/getUserInfoByPhone`,
      host: config.HOST_MALL,
      params
    });
  }
  /**
   * 是否是MSZ 0否 1是
   */
  static getMSZInfo(params) {
    return request({
      url: `user/info/check/user`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 查找代客，客对应的订单类型名称
   */
  static queryOrderTypeInfo(params) {
    return request({
      url: 'basic/orderType/byCardCode',
      host: config.HOST_MALL,
      params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Store/BusinessManage/AgentRegister/AgentRegisterServ.js